import { useEffect } from 'react';
import { useSiteSettings } from '@/hooks/useSiteSettings';

const CustomHeadScript = () => {
  const { settings, loading } = useSiteSettings();

  useEffect(() => {
    if (loading || !settings.custom_head_script) return;

    const script = settings.custom_head_script.trim();
    if (!script) return;

    // Create a container div to parse the HTML content
    const container = document.createElement('div');
    container.innerHTML = script;

    // Extract all script elements and other elements
    const elements: HTMLElement[] = [];
    
    container.childNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        const element = node as HTMLElement;
        
        if (element.tagName === 'SCRIPT') {
          // For script tags, we need to create new ones to execute them
          const newScript = document.createElement('script');
          
          // Copy attributes
          Array.from(element.attributes).forEach((attr) => {
            newScript.setAttribute(attr.name, attr.value);
          });
          
          // Copy inline content
          if (element.textContent) {
            newScript.textContent = element.textContent;
          }
          
          newScript.setAttribute('data-custom-head-script', 'true');
          elements.push(newScript);
        } else {
          // For other elements (like meta, link, etc.)
          const clone = element.cloneNode(true) as HTMLElement;
          clone.setAttribute('data-custom-head-script', 'true');
          elements.push(clone);
        }
      }
    });

    // Remove existing custom scripts before adding new ones
    document.querySelectorAll('[data-custom-head-script="true"]').forEach((el) => {
      el.remove();
    });

    // Append all elements to head
    elements.forEach((element) => {
      document.head.appendChild(element);
    });

    // Cleanup function
    return () => {
      document.querySelectorAll('[data-custom-head-script="true"]').forEach((el) => {
        el.remove();
      });
    };
  }, [settings.custom_head_script, loading]);

  return null;
};

export default CustomHeadScript;
